import { z } from 'zod'
import { baseSchema } from './base'
import { buttonSchema } from './button'
import { formSchema } from './form'
import { tableSchema } from './table'

/**
 * 查询列表组件
 * 接口返回的数据格式
 * {
 *   rows: any[]
 *   total: number
 * }
 */

export const queryListSchema = baseSchema.extend({
  type: z.literal('query-list'),
  url: z.string(),
  code: z.string().optional().describe('权限编号'),
  method: z.enum(['GET', 'POST']).default('GET'),
  onePage: z.boolean().optional(),
  headers: z.record(z.string(), z.any()).optional(),
  body: z.record(z.string(), z.any()).optional().describe('请求体。支持模板字符串，可以在此处做数据映射。'),
  params: z.record(z.string(), z.any()).optional().describe('查询参数。支持模板字符串，可以在此处做数据映射。'),
  extra: z.any().array().optional().describe('表格额外配置'),
  actions: buttonSchema.array().optional().describe('表格操作。会自动把该行的表格数据沿着组件树逐级往下传递。'),
  buttonsAlign: z.enum(['left', 'right', 'bottom']).optional(),
  formLayout: formSchema.shape.layout,
  gutter: formSchema.shape.gutter,
  fields: formSchema.shape.fields,
  initialValues: formSchema.shape.initialValues,
  rowKey: tableSchema.shape.rowKey,
  tableLayout: tableSchema.shape.tableLayout,
  footer: tableSchema.shape.footer,
  columns: tableSchema.shape.columns,
})

export type QueryListSchema = z.infer<typeof queryListSchema>
